import $api from "../http";
import { IClassForTable, IClassUpdateModel, IClassUpdateResult } from "../models/Class";

class ClassServiceClass {
  async getAllClassesByGymListingId(gymListingId: string, searchValue: string | null) {
    const query = searchValue ? `?searchValue=${searchValue}` : "";
    return await $api.get<IClassForTable[]>(`api/class/all-by-gym/${gymListingId}${query}`);
  }

  async updateClassByGymListingId(gymListingId: string, model: IClassUpdateModel) {
    return await $api.put<IClassUpdateResult>(`api/class/${gymListingId}`, model);
  }
}

export const ClassService = new ClassServiceClass();
